<template>
    <span
        :class="classes"
    >
        {{ text }}
    </span>
</template>

<script>

export default {
    props: {
        text: {
            type: String,
        },
        badgeClass: {
            type: String,
            default:'primary'
        },
    },
    data() {
        return {
            defaultBtnClasses: 'inline-block py-1.5 px-2.5 leading-none text-center whitespace-nowrap align-baseline font-bold text-white rounded m-1 text-xs',
        }
    },
    computed: {
        classes() {
            let btnClasses = this.defaultBtnClasses
            switch (this.badgeClass){
                case 'primary' :
                    btnClasses += ' bg-blue-600'
                    break
                case 'secondary' :
                    btnClasses += ' bg-purple-600'
                    break
                case 'success' :
                    btnClasses += ' bg-green-500'
                    break
                case 'danger' :
                    btnClasses += ' bg-red-600'
                    break
                case 'warning' :
                    btnClasses += ' bg-yellow-500'
                    break
                case 'info' :
                    btnClasses += ' bg-blue-400'
                    break
                case 'light' :
                    btnClasses = btnClasses.replace('text-white', 'text-gray-700')
                    btnClasses += ' bg-gray-200'
                    break
                case 'dark' :
                    btnClasses += ' bg-gray-800'
                    break
            }
            return  btnClasses
        },
    },
}
</script>
